/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paymentproviderunavailableerror3Inputs */

const en_paymentproviderunavailableerror3 = /** @type {(inputs: Paymentproviderunavailableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments are temporarily unavailable. Please try again in a few minutes.`)
};

const de_paymentproviderunavailableerror3 = /** @type {(inputs: Paymentproviderunavailableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungen sind gerade nicht möglich. Bitte versuche es in ein paar Minuten erneut.`)
};

/**
* | output |
* | --- |
* | "Payments are temporarily unavailable. Please try again in a few minutes." |
*
* @param {Paymentproviderunavailableerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const paymentproviderunavailableerror3 = /** @type {((inputs?: Paymentproviderunavailableerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paymentproviderunavailableerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paymentproviderunavailableerror3(inputs)
	return de_paymentproviderunavailableerror3(inputs)
});
export { paymentproviderunavailableerror3 as "paymentProviderUnavailableError" }